export const fetchCadastroAtoAction = () => ({ type: 'FETCH_CADASTRO_ATO' });
export const fetchCadastroAtoActionSuccess = data => ({ type: 'FETCH_CADASTRO_ATO_SUCCESS', data });
export const fetchCadastroAtoActionError = error => ({ type: 'FETCH_CADASTRO_ATO_ERROR', error });
